import script from "./pc-module-catalogue-5.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-catalogue-5.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-catalogue-5.vue?vue&type=style&index=0&id=bdfe8bea&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bdfe8bea"]])

export default __exports__